<cac-dialog-layout
  [title]="data.blog ? 'Edit Blog' : 'Create New Blog'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <cac-image-uploader [control]="image" [options]="options" class="h-44" />

  <div class="mt-5 mb-6 mt-8">
    <cac-field
      label="Title"
      [control]="titleAndSubTitleForm.controls.title"
      controlType="input"
      appearance="outlined"
      placeholder="Enter blog title"
    ></cac-field>
    <div class="text-xs text-gray-500 mt-[-8px] text-right">{{ titleCharCount() }}/{{ titleMaxLength }} characters</div>
  </div>

  <div class="mb-6">
    <cac-field
      label="Sub Title"
      [control]="titleAndSubTitleForm.controls.subTitle"
      controlType="input"
      appearance="outlined"
      placeholder="Enter blog subtitle"
    ></cac-field>
    <div class="text-xs text-gray-500 mt-[-8px] text-right">
      {{ subTitleCharCount() }}/{{ subTitleMaxLength }} characters
    </div>
  </div>

  <cac-form-builder [options]="form" class="mt-2" />
  <div *ngIf="form.controls.tags.value && form.controls.tags.value.length > 0" class="mt-4">
    <div class="flex flex-wrap gap-2">
      <div
        *ngFor="let tagId of form.controls.tags.value"
        class="bg-gray-100 rounded-full px-3 py-1 text-sm flex items-center"
      >
        {{ getTagName(tagId) }}
        <button class="ml-2 text-gray-500 hover:text-gray-700" (click)="removeTag(tagId)">×</button>
      </div>
    </div>
  </div>

  <div class="flex gap-3 mt-4">
    <cac-button class="w-fit" (onClick)="openEditor()">Open Editor</cac-button>
    <cac-button class="w-fit" appearance="stroked" (onClick)="saveDraft()">Save as Draft</cac-button>

    <cac-button
      *ngIf="data.blog?.isDraft"
      class="w-fit"
      appearance="stroked"
      color="warn"
      (onClick)="restorePreviousVersion()"
    >
      Restore Previous Version
    </cac-button>
  </div>
</cac-dialog-layout>
